import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch
} from '@mui/material';

interface CreateVoucherModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (voucherData: {
    code: string;
    type: number;
    amount: number;
    cap: number;
    limit: number;
    isActive: boolean;
  }) => void;
  loading: boolean;
}

const CreateVoucherModal: React.FC<CreateVoucherModalProps> = ({
  open,
  onClose,
  onSubmit,
  loading
}) => {
  const [formData, setFormData] = useState({
    code: '',
    type: 1,
    amount: 0,
    cap: 0,
    limit: 0,
    isActive: true
  });

  const handleSubmit = () => {
    if (!formData.code.trim()) {
      return;
    }
    onSubmit(formData);
  };

  const handleReset = () => {
    setFormData({
      code: '',
      type: 1,
      amount: 0,
      cap: 0,
      limit: 0,
      isActive: true
    });
  };


  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Voucher</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Voucher Code"
            value={formData.code}
            onChange={(e) => setFormData(prev => ({ ...prev, code: e.target.value }))}
            sx={{ mb: 2 }}
          />
          
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Type</InputLabel>
            <Select
              value={formData.type}
              onChange={(e) => setFormData(prev => ({ ...prev, type: e.target.value as number }))}
              label="Type"
            >
              <MenuItem value={1}>Additional Credits</MenuItem>
              <MenuItem value={2}>Discount Fixed Amount</MenuItem>
              <MenuItem value={3}>Discount % up to Cap</MenuItem>
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Amount"
            type="number"
            value={formData.amount}
            onChange={(e) => setFormData(prev => ({ ...prev, amount: parseInt(e.target.value) || 0 }))}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Cap"
            type="number"
            value={formData.cap}
            onChange={(e) => setFormData(prev => ({ ...prev, cap: parseInt(e.target.value) || 0 }))}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Limit"
            type="number"
            value={formData.limit}
            onChange={(e) => setFormData(prev => ({ ...prev, limit: parseInt(e.target.value) || 0 }))}
            sx={{ mb: 2 }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={formData.isActive}
                onChange={(e) => setFormData(prev => ({ ...prev, isActive: e.target.checked }))}
                color="primary"
              />
            }
            label="Active"
            sx={{ mb: 2 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleReset} disabled={loading}>
          Reset
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          disabled={loading || !formData.code.trim()}
        >
          {loading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateVoucherModal;